import { render } from "./UsefulInformation.vue?vue&type=template&id=c8aeb4e0&scoped=true"
import script from "./UsefulInformation.vue?vue&type=script&lang=js"
export * from "./UsefulInformation.vue?vue&type=script&lang=js"

import "./UsefulInformation.vue?vue&type=style&index=0&id=c8aeb4e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8aeb4e0"]])

export default __exports__